var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.5 0C6.93948 0 0 6.93948 0 15.5C0 24.0605 6.93948 31 15.5 31C24.0605 31 31 24.0605 31 15.5C31 6.93948 24.0605 0 15.5 0ZM19.1716 10.7111H16.8417C16.5656 10.7111 16.2589 11.0744 16.2589 11.5572V13.2396H19.1732L18.7324 15.6389H16.2589V22.8415H13.5092V15.6389H11.0147V13.2396H13.5092V11.8284C13.5092 9.80375 14.9139 8.15849 16.8417 8.15849H19.1716V10.7111Z","fill":"#3B2E2D"}));
}

FacebookIcon.defaultProps = {"width":"31","height":"31","viewBox":"0 0 31 31","fill":"none"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
